import React, { useEffect } from 'react';
import type { PropsWithChildren } from 'react';
import { Flex } from '@balance-web/flex';

import { Loader } from '../../components/design-system/Loader';
import { useBookid } from '../Book/useBookId';

import { useGetUserPermissionsQuery } from './useGetUserPermissionsQuery';
import { PermissionsContext } from './PermissionsContext';

type PermissionsProviderProps = PropsWithChildren<{}>;

export function PermissionsProvider({ children }: PermissionsProviderProps) {
  const { bookId } = useBookid();
  const {
    permissions,
    isLoading,
    hasPermission,
    error,
  } = useGetUserPermissionsQuery({
    skip: !bookId,
    bookId,
  });

  // bubble up to error boundary
  useEffect(() => {
    if (isLoading) {
      return;
    }
    if (error) {
      throw new Error(error);
    }
  }, [error, isLoading]);

  if (isLoading) {
    return (
      <Flex flexGrow={1}>
        <Loader label="Fetching data" />
      </Flex>
    );
  }

  return (
    <PermissionsContext.Provider
      value={{
        permissions,
        hasPermission,
      }}
    >
      {children}
    </PermissionsContext.Provider>
  );
}
